// react
import React from "react";
import ReactDOM from "react-dom";

// components
import Icon from "../../components/Icon";

import PropTypes from "../../lib/prop-types";

// const PageCurtainRoot = document.getElementById('react-page-curtain-root');

export default class PageCurtain extends React.Component {
	static propTypes = {
		removeOuterScroll: PropTypes.bool,
		portalRoot: PropTypes.string,
		className: PropTypes.string,
		onClose: PropTypes.func.isRequired,
		children: PropTypes.element.isRequired,
		color: PropTypes.oneOf(["black", "white"]),
	};

	static defaultProps = {
		className: "",
		color: "white",
		removeOuterScroll: false,
		portalRoot: "react-page-curtain-root",
	};

	constructor(props) {
		super(props);
		this.el = document.createElement("div");
		this.PageCurtainRoot = document.getElementById(this.props.portalRoot);
	}

	componentDidMount() {
		this.PageCurtainRoot.appendChild(this.el);
		window.addEventListener("keydown", this.onWindowKeydown);

		// remove html scrolling if true
		if (this.props.removeOuterScroll) {
			document.querySelector("html").style.overflow = "hidden";
		}
	}

	componentWillUnmount() {
		this.PageCurtainRoot.removeChild(this.el);
		window.removeEventListener("keydown", this.onWindowKeydown);

		document.querySelector("html").style.overflow = null;
	}

	onWindowKeydown = (event) => {
		const { key } = event;

		if (key === "Escape") {
			this.handleClose();
		}
	};

	handleClose = () => {
		this.props.onClose();
	};

	render() {
		const { className, color } = this.props;

		return ReactDOM.createPortal(
			<div className={`page-curtain-portal ${color} ${className}`}>
				<section className="portal-content">{this.props.children}</section>

				<div className="close-curtain" onClick={this.handleClose} onKeyPress={this.handleKeyPress}>
					<Icon type="material" name="close" size={50} />
				</div>
			</div>,
			this.el
		);
	}
}
